import React, { memo } from 'react'
import PropTypes from 'prop-types'

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, checked, validateSelectable, ...rest }, ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate, checked])

    return (
      <input
        type="checkbox"
        checked={checked}
        disabled={!validateSelectable?.()}
        ref={resolvedRef}
        {...rest}
      />
    )
  },
)

IndeterminateCheckbox.displayName = 'IndeterminateCheckbox'

IndeterminateCheckbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  validateSelectable: PropTypes.func,
}

export default memo(IndeterminateCheckbox)
